import styles from './ItineraryAccordion.module.scss'
import Accordion from '@/components/elements/Accordion'
import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'next-i18next'
import { ExtendedItineraryItem } from '@/interfaces'
import CloudinaryImage from '@/components/elements/media/CloudinaryImage'

interface Props {
  extendedItineraryItems: ExtendedItineraryItem[]
  collapsed?: boolean
}

const ItineraryAccordion = ({ extendedItineraryItems, collapsed }: Props) => {
  const { t } = useTranslation('common')
  const colSizes = [1, 3]

  let items = extendedItineraryItems.map((item) => {
    // date
    return {
      title: (
        <Row>
          <Col md={colSizes[0]} className="d-none d-md-block">
            {item.dayString}
          </Col>
          <Col md={colSizes[1]} className={styles.dateWrap}>
            {item.dateString}
          </Col>
          <Col className="me-4">{item.title}</Col>
        </Row>
      ),
      content: (
        <Row>
          <Col md={colSizes[0] + colSizes[1]} className={styles.imageCol}>
            {item.image.publicId && (
              <CloudinaryImage
                className={styles.image}
                image={item.image}
                width={item.image.width >= item.image.height ? 200 : undefined}
                height={item.image.width < item.image.height ? 200 : undefined}
                altDefault={item.image.description}
                aspectRatio={item.image.width >= item.image.height ? 1.777 : 0.562}
                responsive={false}
              />
            )}
          </Col>
          <Col md={12 - (colSizes[0] + colSizes[1])} className={styles.contentCol}>
            <div className={styles.text} dangerouslySetInnerHTML={{ __html: item.text }} />
          </Col>
        </Row>
      ),
    }
  })

  return (
    <div className={styles.root}>
      <div className="d-none d-md-block">
        <Row className={styles.header}>
          <Col md={colSizes[0]}>{t('travel.itinerary.day')}</Col>
          <Col md={colSizes[1]} className={styles.dateHeading}>
            {t('travel.itinerary.date')}
          </Col>
          <Col>{t('travel.itinerary.program')}</Col>
        </Row>
      </div>
      <Accordion
        items={items}
        className={`mb-3 ${styles.accordion}`}
        collapsed={collapsed}
        trackingCategoryAndObject={'travel_page:itinerary_accordion_item'}
      />
    </div>
  )
}

export default ItineraryAccordion
